<div class="flex justify-between my-2">
  <div class="bg-gray-300 animate-pulse rounded-full h-10 w-10"></div>
  <div class="flex flex-col -ml-6">
    <div class="bg-gray-300 animate-pulse rounded-lg h-4 w-24 mb-2"></div>
    <div class="bg-gray-300 animate-pulse rounded-lg h-4 w-32"></div>
  </div>
  <div class="bg-gray-300 animate-pulse rounded-lg h-4 w-8"></div>
  <div class="bg-gray-300 animate-pulse rounded-lg h-4 w-10"></div>
</div>
